import { useDeviceType } from '@cian/ui-kit/responsive';
import * as React from 'react';

import { ActivePolygonSync } from './ActivePolygonSync';
import { PolygonClickHandlers } from './PolygonClickHandlers';
import { PolygonHoverHandlers } from './PolygonHoverHandlers';
import { PolygonsManager } from './PolygonsManager';
import { NewbuildingPolygonsContext, INewbuildingPolygonsContext } from './context';
import { useMapContext } from '../../context';

export const NewbuildingsPolygonsContainer: React.FC = () => {
  const { ymaps, map } = useMapContext();
  const deviceType = useDeviceType();
  const isDesktop = deviceType === 'desktop';
  const newbuildingsPolygonsManagerRef = React.useRef(new ymaps.NewbuildingsPolygonsManager(isDesktop));
  /* oxlint-disable react/exhaustive-deps */
  React.useEffect(() => {
    map.geoObjects.add(newbuildingsPolygonsManagerRef.current.objectManager);

    return () => {
      map.geoObjects.remove(newbuildingsPolygonsManagerRef.current.objectManager);
    };
  }, []);

  const context = React.useMemo<INewbuildingPolygonsContext>(
    () => ({
      newbuildingsPolygonsManager: newbuildingsPolygonsManagerRef.current,
    }),
    [],
  );

  return (
    <NewbuildingPolygonsContext.Provider value={context}>
      <PolygonClickHandlers />
      {isDesktop && <PolygonHoverHandlers />}
      <ActivePolygonSync />
      <PolygonsManager />
    </NewbuildingPolygonsContext.Provider>
  );
};
